module.exports = __webpack_public_path__ + "img/19.28ce044d.png";